/**
 * Resatravel booking iframe resize (legacy script)
 */

const resatravelEngine = document.getElementById('resatravel_engine');

if (resatravelEngine) {
  window.addEventListener(
    'message',
    function (event) {
      if (event.data) {
        try {
          let data = JSON.parse(event.data);
          if (data.source == 'engine' && data.event == 'resize') {
            document.getElementById('resatravel_engine').style.height = data.newHeight + 'px';
          }
        } catch (error) {
          console.error('Failed to parse message data:', error);
        }
      }
    },
    false
  );
}
